var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 1 1 3 0zm0 0",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.102 9.75c.832 0 1.348.81 1.348 1.688v4.688c0 .672.29 1.125.45 1.125h.602a.75.75 0 1 1 0 1.5h-.602c-1.164 0-1.95-1.227-1.95-2.625v-4.687c0-.156-.02-.187.152-.187H10.5a.75.75 0 1 1 0-1.5zM11.625 6c.62 0 1.125.504 1.125 1.125s-.504 1.125-1.125 1.125S10.5 7.746 10.5 7.125 11.004 6 11.625 6zM12 24a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm0-1.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 1 1 0 21zm0 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.42a52ff4998d1277a034892e1c5680cc.svg";
export { ForwardRef as ReactComponent };